/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TTLOListItem,
    TTLOListItemFromJSON,
    TTLOListItemFromJSONTyped,
    TTLOListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOListItemPaginationWrapper
 */
export interface TTLOListItemPaginationWrapper {
    /**
     * 
     * @type {Array<TTLOListItem>}
     * @memberof TTLOListItemPaginationWrapper
     */
    items?: Array<TTLOListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof TTLOListItemPaginationWrapper
     */
    totalItems?: number;
}

export function TTLOListItemPaginationWrapperFromJSON(json: any): TTLOListItemPaginationWrapper {
    return TTLOListItemPaginationWrapperFromJSONTyped(json, false);
}

export function TTLOListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(TTLOListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function TTLOListItemPaginationWrapperToJSON(value?: TTLOListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(TTLOListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


